import { AddBox, Clear, Search } from '@mui/icons-material';
import { Tooltip, IconButton, FormControl, InputLabel, Input, Paper } from '@mui/material';
import TextField from '@mui/material/TextField';
import { styled } from '@mui/styles';
import { action, observable, runInAction, makeObservable } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';
import LayoutStore from '../store/LayoutStore';
// import '../css/botao.css';
import UtilNumeroProcesso from '../utils/UtilNumeroProcesso';

const styleNumero = {
    width: '67px',
};

const styleDigito = {
    width: '22px',
};

const styleAno = {
    width: '40px',
};

const styleOrgao = {
    width: '13px',
};

const styleRegional = {
    width: '22px',
};

const styleVara = {
    width: '40px',
};

const CssTextField = styled(TextField)({
    // root: {
    '& label.Mui-focused': {
        color: 'white',
    },
    '& .MuiInput-underline:after': {

    },
    '& .MuiOutlinedInput-root': {
        '& fieldset': {
            borderTop: 'none',
            borderLeft: 'none',
            borderRight: 'none',
            borderRadius: 0,
            borderBottomColor: 'white',
        },
        '&:hover fieldset': {
            borderTop: 'none',
            borderLeft: 'none',
            borderRight: 'none',
            borderRadius: 0,
            borderBottomColor: 'white',
        },
        '&.Mui-focused fieldset': {
            borderTop: 'none',
            borderLeft: 'none',
            borderRight: 'none',
            borderRadius: 0,
            borderBottomColor: 'white',
        },
    },
    '& .MuiSvgIcon-root': {
        color: 'white'
    }
    // }
});

interface IPropsNumeroDeProcesso {
    classe?: string;
    numero?: string;
    digito?: string;
    ano?: string;
    orgao?: string;
    regional?: string;
    vara?: string;
    pesquisarComEnter?: boolean;
    getNumeroProcesso?: (param1) => any;
    isDisabled?: boolean;
    classFormControl?: string;
    callback?: (any) => any;
    callbackOnBlur?: (any) => any;
    clickSearch?: (any) => any;
    classInputLabel?: string;
    tooltip?: string;
    exibirBotaoIncluir?: boolean;
    white?: boolean;
    hasFocus?: boolean;
}

class NumeroDeProcesso extends React.Component<IPropsNumeroDeProcesso> {
    classe = this.props.classe ? this.props.classe : '';
    numero = this.props.numero ? this.props.numero : '';
    digito = this.props.digito ? this.props.digito : '';
    ano = this.props.ano ? this.props.ano : '';
    orgao = this.props.orgao ? this.props.orgao : '';
    regional = this.props.regional ? this.props.regional : '';
    vara = this.props.vara ? this.props.vara : '';
    refNumero = React.createRef();
    refDigito = React.createRef();
    refAno = React.createRef();
    refOrgao = React.createRef();
    refRegional = React.createRef();
    refVara = React.createRef();

    handleNumeroEvent = (event) => {
        const num = event.target.value;
        this.handleNumero(num);
    }

    handleNumero = (num) => {
        //num = num.replace(/^0+/, ''); // Permitindo colocar os zeros antes igual ao pje
        if (num.indexOf('-') > 0) {
            const [classe, numero] = num.split(' - ');
            const NUMERO_PROCESSO_PATTERN = /([0-9]+)[.-]([0-9]+).([0-9]+).([0-9]+).([0-9]+).([0-9]+)/;
            const match = NUMERO_PROCESSO_PATTERN.exec(num);
            if (match !== null) {

                this.classe = numero ? classe : numero;
                this.numero = match[1].toString().replace(/\s/g, '').substring(0, 7);
                this.digito = UtilNumeroProcesso.preencheZeros(match[2], 2).toString().replace(/\s/g, '').substring(0, 2);
                this.ano = match[3].toString().replace(/\s/g, '').substring(0, 4);
                this.orgao = match[4].toString().replace(/\s/g, '').substring(0, 1);
                this.regional = UtilNumeroProcesso.preencheZeros(match[5], 2).toString().replace(/\s/g, '').substring(0, 2);
                this.vara = UtilNumeroProcesso.preencheZeros(match[6], 4).toString().replace(/\s/g, '').substring(0, 4);
            } else {
                this.handleApenasNumero(num);
            }
        } else {
            if (num.length === 20) {
                num = num.replace(/(\d)(\d{2})(\d{4})(\d{1})(\d{2})(\d{4})$/, "$1-$2.$3.$4.$5.$6");
                const NUMERO_PROCESSO_PATTERN = /([0-9]+)[.-]([0-9]+).([0-9]+).([0-9]+).([0-9]+).([0-9]+)/;
                const match = NUMERO_PROCESSO_PATTERN.exec(num);

                if (match !== null) {
                    this.numero = match[1].toString().substring(0, 7);
                    this.digito = match[2].toString().substring(0, 2);
                    this.ano = match[3].toString().substring(0, 4);
                    this.orgao = match[4].toString().substring(0, 1);
                    this.regional = UtilNumeroProcesso.preencheZeros(match[5], 2).toString().substring(0, 2);
                    this.vara = UtilNumeroProcesso.preencheZeros(match[6], 4).toString().substring(0, 4);
                }
                return;
            } else if (num.length > 6) {
                num = num.toString().substring(0, 7);
                (this.refDigito.current as any).focus();
            }
            this.numero = num.replace(/\D+/g, '').trim();
        }
        this.props.getNumeroProcesso && this.props.getNumeroProcesso(this.getNumeroProcesso());
    };

    handleApenasNumero = (num) => {
        const numeroSeparado = num.split('-');
        this.numero = numeroSeparado[0].trim().toString().substring(0, 7);

        if (numeroSeparado[1]) {
            const restoNumeroUnico = numeroSeparado[1].split('.');

            this.digito = restoNumeroUnico[0] ? restoNumeroUnico[0].toString().replace(/\s/g, '').substring(0, 2) : '';
            this.ano = restoNumeroUnico[1] ? restoNumeroUnico[1].toString().replace(/\s/g, '').substring(0, 4) : '';
            this.orgao = restoNumeroUnico[2] ? restoNumeroUnico[2].toString().replace(/\s/g, '').substring(0, 1) : '';
            this.regional = restoNumeroUnico[3] ? restoNumeroUnico[3].toString().replace(/\s/g, '').substring(0, 2) : '';
            this.vara = restoNumeroUnico[4] ? restoNumeroUnico[4].toString().replace(/\s/g, '').substring(0, 4) : '';
        }
    };

    handleDigito = (event) => {

        let dig = event.target.value.replace(/\D+/g, '').trim();

        if (dig.length > 1) {
            dig = dig.toString().substring(0, 2);
            (this.refAno.current as any).focus();
        } else if (dig.length === 0) {
            (this.refNumero.current as any).focus();
        }
        this.digito = dig;
        this.props.getNumeroProcesso && this.props.getNumeroProcesso(this.getNumeroProcesso());
    };

    handleAno = (event) => {

        let ano = event.target.value.replace(/\D+/g, '').trim();
        ano = ano.replace(/^0+/, '');
        if (ano.length > 3) {
            ano = ano.toString().substring(0, 4);
            (this.refOrgao.current as any).focus();
        } else if (ano.length === 0) {
            (this.refDigito.current as any).focus();
        }
        this.ano = ano;
        this.props.getNumeroProcesso && this.props.getNumeroProcesso(this.getNumeroProcesso());
    };

    handleOrgao = (event) => {
        let org = event.target.value.replace(/\D+/g, '').trim();
        org = org.replace(/^0+/, '');

        if (org.length === 0) {
            (this.refAno.current as any).focus();
        } else {
            org = org.toString().substring(0, 1);
            (this.refRegional.current as any).focus();
        }
        this.orgao = org;
        this.props.getNumeroProcesso && this.props.getNumeroProcesso(this.getNumeroProcesso());
    };

    handleRegional = (event) => {
        let reg = event.target.value.replace(/\D+/g, '').trim();

        if (reg.length > 1) {
            reg = reg.toString().substring(0, 2);
            (this.refVara.current as any).focus();
        } else if (reg.length === 0) {
            (this.refOrgao.current as any).focus();
        }
        this.regional = reg;
        this.props.getNumeroProcesso && this.props.getNumeroProcesso(this.getNumeroProcesso());
    };

    handleVara = (event) => {
        let vara = event.target.value.replace(/\D+/g, '').trim();
        if (vara.length > 4) {
            vara = vara.toString().substring(0, 5);
            return;
        } else if (vara.length === 0) {
            (this.refRegional.current as any).focus();
        }
        this.vara = vara;
        this.props.getNumeroProcesso && this.props.getNumeroProcesso(this.getNumeroProcesso());
    };

    getNumeroProcesso = () => {
        return {
            classe: this.classe,
            numero: this.numero,
            digito: this.digito,
            ano: this.ano,
            orgao: this.orgao,
            regional: this.regional,
            vara: this.vara,
            isAlgumPreenchido: this.numero.length > 0 || this.digito.length > 0 || this.ano.length > 0 || this.orgao.length > 0 || this.regional.length > 0 || this.vara.length > 0,
            numeroFormatado: this.numero + '-' + this.digito + '.' + this.ano + '.' + this.orgao + '.' + this.regional + '.' + this.vara
        };
    }

    qualquerCampoPreenchido = () => {
        return this.numero || this.digito || this.ano || this.orgao || this.regional || this.vara;
    }

    handleClicklimpar = () => {
        this.numero = "";
        this.digito = "";
        this.ano = "";
        this.orgao = "";
        this.regional = "";
        this.vara = "";
        (this.refNumero.current as any).focus();
        this.props.getNumeroProcesso && this.props.getNumeroProcesso(this.getNumeroProcesso());
    };

    constructor(props: IPropsNumeroDeProcesso) {
        super(props);

        makeObservable(this, {
            classe: observable,
            numero: observable,
            digito: observable,
            ano: observable,
            orgao: observable,
            regional: observable,
            vara: observable,
            handleNumero: action,
            handleApenasNumero: action,
            handleDigito: action,
            handleAno: action,
            handleOrgao: action,
            handleRegional: action,
            handleVara: action,
            handleClicklimpar: action
        });
    }

    componentDidMount() {
        (document.querySelector("#numero") as HTMLElement).style.textAlign = 'left';
        if (this.props.hasFocus) {
            (document.querySelector("#numero") as HTMLElement).focus();
        }
    }

    componentDidUpdate(prevProps: IPropsNumeroDeProcesso) {
        // Quando o componente pai limpa um campo (prop passa a vazio), reflete no estado local.
        // Antes isso era feito por reactions que liam this.props em contexto reativo (erro do mobx-react).
        const limparSeEsvaziou = (campo: 'numero' | 'digito' | 'ano' | 'orgao' | 'regional' | 'vara') => {
            if (prevProps[campo] !== this.props[campo] && !(this.props[campo]?.length > 0)) {
                this[campo] = '';
            }
        };
        runInAction(() => {
            limparSeEsvaziou('numero');
            limparSeEsvaziou('digito');
            limparSeEsvaziou('ano');
            limparSeEsvaziou('orgao');
            limparSeEsvaziou('regional');
            limparSeEsvaziou('vara');
        });
    }

    pressKey = (ev) => {
        if (ev?.key.indexOf('Enter') > -1) {
            if (document.activeElement == document.getElementById('numero')) {
                document.getElementById('digito').focus();
                return;
            }
            if (this.props.pesquisarComEnter) {
                this.props.clickSearch(this.getNumeroProcesso())
            } else {
                this.props.callback && this.props.callback(this.getNumeroProcesso());
            }
        }
    }

    selecionaTexto = (event) => {
        event.target.select();
    }

    handleClickSearch = () => {
        this.props.clickSearch(this.getNumeroProcesso())
    }

    handleClickIncluir = () => {
        this.props.callback && this.props.callback(this.getNumeroProcesso());
    }

    onBlur = () => {
        this.props.callbackOnBlur && this.props.callbackOnBlur(this.getNumeroProcesso());
    }

    render() {
        const inputInternoProps = {
            style: {
                paddingTop: '0', paddingBottom: '0', paddingLeft: '0.2ch', paddingRight: '0.2ch'
            }
        };
        return (

            <FormControl fullWidth className={this.props.classFormControl ? this.props.classFormControl + ' widthCamposCheck mediaQueryNumProc' : 'mediaQueryNumProc'} style={{
                marginTop: '5px'
            }}>
                <Paper className={!LayoutStore.isTemaDark ? (this.props.white ? 'paperFiltrosWhite' : 'paperFiltros') : 'paperFiltrosDark'}
                       sx={this.props.white ? {
                        display       : 'flex',
                        flexDirection: 'column',
                        marginRight  : '33px',
                        padding       : '10px',
                        backgroundColor: '#093170',
                        color: 'white',
                        borderColor: 'white !important' } :
                {
                    borderColor: 'white'
                }}
                       variant="outlined">
                    <InputLabel shrink className={this.props.classInputLabel ? this.props.classInputLabel : ''} sx={{marginTop: '20px'}} id='labelNumeroProcesso'>Digite o número do processo completo ou parte dele</InputLabel>
                    <div style={{ display: 'flex', flexDirection: 'row', minWidth: '50px', alignItems: 'center', marginTop: '20px'}}>
                        <Tooltip title={this.props.tooltip ? this.props.tooltip : ''} placement='top'>
                            <div style={{ display: 'inline-table', alignItems: 'flex' }} className="classNameNumeroProcesso">
                                {this.props.white ?
                                    <CssTextField
                                        onKeyUp={this.pressKey}
                                        id="numero"
                                        name="numero"
                                        style={styleNumero}
                                        inputProps={inputInternoProps}
                                        value={this.numero}
                                        onChange={this.handleNumeroEvent}
                                        inputRef={this.refNumero}
                                        disabled={this.props.isDisabled}
                                        onClick={this.selecionaTexto}
                                        onBlur={this.onBlur}
                                        size='small'
                                    />
                                    :
                                    <TextField
                                        onKeyUp={this.pressKey}
                                        id="numero"
                                        name="numero"
                                        style={styleNumero}
                                        inputProps={inputInternoProps}
                                        value={this.numero}
                                        onChange={this.handleNumeroEvent}
                                        inputRef={this.refNumero}
                                        disabled={this.props.isDisabled}
                                        onClick={this.selecionaTexto}
                                        onBlur={this.onBlur}
                                        size='small'
                                    />
                                }
                                <span style={{margin: 5}} >
                                    -
                                </span>
                                {this.props.white ?
                                    <CssTextField
                                        id="digito"
                                        name="digito"
                                        style={styleDigito}
                                        value={this.digito}
                                        onChange={this.handleDigito}
                                        inputRef={this.refDigito}
                                        inputProps={inputInternoProps}
                                        rows={1}
                                        disabled={this.props.isDisabled}
                                        onKeyUp={this.pressKey}
                                        onClick={this.selecionaTexto}
                                        size='small'
                                        onBlur={this.onBlur}
                                    />
                                    :
                                    <TextField
                                        id="digito"
                                        name="digito"
                                        style={styleDigito}
                                        value={this.digito}
                                        onChange={this.handleDigito}
                                        inputRef={this.refDigito}
                                        inputProps={inputInternoProps}
                                        rows={1}
                                        disabled={this.props.isDisabled}
                                        onKeyUp={this.pressKey}
                                        onClick={this.selecionaTexto}
                                        size='small'
                                        onBlur={this.onBlur}
                                    />}
                                <span style={{ whiteSpace: 'pre-wrap' }} >
                                    {" . "}
                                </span>
                                {this.props.white ?
                                    <CssTextField
                                        id="ano"
                                        name="ano"
                                        style={styleAno}
                                        value={this.ano}
                                        onChange={this.handleAno}
                                        inputRef={this.refAno}
                                        inputProps={inputInternoProps}
                                        rows={1}
                                        disabled={this.props.isDisabled}
                                        onKeyUp={this.pressKey}
                                        onClick={this.selecionaTexto}
                                        onBlur={this.onBlur}
                                        size='small'
                                    />
                                    :
                                    <TextField
                                        id="ano"
                                        name="ano"
                                        style={styleAno}
                                        value={this.ano}
                                        onChange={this.handleAno}
                                        inputRef={this.refAno}
                                        inputProps={inputInternoProps}
                                        rows={1}
                                        disabled={this.props.isDisabled}
                                        onKeyUp={this.pressKey}
                                        onClick={this.selecionaTexto}
                                        onBlur={this.onBlur}
                                        size='small'
                                    />}
                                <span style={{ whiteSpace: 'pre-wrap' }} >
                                    {" . "}
                                </span>
                                {this.props.white ?
                                    <CssTextField
                                        id="orgao"
                                        style={styleOrgao}
                                        value={this.orgao}
                                        onChange={this.handleOrgao}
                                        inputRef={this.refOrgao}
                                        inputProps={inputInternoProps}
                                        rows={1}
                                        disabled={this.props.isDisabled}
                                        onKeyUp={this.pressKey}
                                        onClick={this.selecionaTexto}
                                        onBlur={this.onBlur}
                                        size='small'
                                    />
                                    :
                                    <TextField
                                        id="orgao"
                                        style={styleOrgao}
                                        value={this.orgao}
                                        onChange={this.handleOrgao}
                                        inputRef={this.refOrgao}
                                        inputProps={inputInternoProps}
                                        rows={1}
                                        disabled={this.props.isDisabled}
                                        onKeyUp={this.pressKey}
                                        onClick={this.selecionaTexto}
                                        onBlur={this.onBlur}
                                        size='small'
                                    />}
                                <span style={{ whiteSpace: 'pre-wrap' }} >
                                    {" . "}
                                </span>
                                {this.props.white ?
                                    <CssTextField
                                        id="regional"
                                        style={styleRegional}
                                        value={this.regional}
                                        onChange={this.handleRegional}
                                        inputRef={this.refRegional}
                                        inputProps={inputInternoProps}
                                        rows={1}
                                        disabled={this.props.isDisabled}
                                        onKeyUp={this.pressKey}
                                        onClick={this.selecionaTexto}
                                        onBlur={this.onBlur}
                                        size='small'
                                    />
                                    :
                                    <TextField
                                        id="regional"
                                        style={styleRegional}
                                        value={this.regional}
                                        onChange={this.handleRegional}
                                        inputRef={this.refRegional}
                                        inputProps={inputInternoProps}
                                        rows={1}
                                        disabled={this.props.isDisabled}
                                        onKeyUp={this.pressKey}
                                        onClick={this.selecionaTexto}
                                        onBlur={this.onBlur}
                                        size='small'
                                    />}
                                <span style={{ whiteSpace: 'pre-wrap' }} >
                                    {" . "}
                                </span>
                                {this.props.white ?
                                    <CssTextField
                                        id="vara"
                                        style={styleVara}
                                        value={this.vara}
                                        onChange={this.handleVara}
                                        inputRef={this.refVara}
                                        inputProps={inputInternoProps}
                                        rows={1}
                                        disabled={this.props.isDisabled}
                                        onKeyUp={this.pressKey}
                                        onClick={this.selecionaTexto}
                                        onBlur={this.onBlur}
                                        size='small'
                                    />
                                    :
                                    <TextField
                                        id="vara"
                                        style={styleVara}
                                        value={this.vara}
                                        onChange={this.handleVara}
                                        inputRef={this.refVara}
                                        inputProps={inputInternoProps}
                                        rows={1}
                                        disabled={this.props.isDisabled}
                                        onKeyUp={this.pressKey}
                                        onClick={this.selecionaTexto}
                                        onBlur={this.onBlur}
                                        size='small'
                                    />}
                            </div>
                        </Tooltip>
                        <Tooltip title={'Limpar'} placement='top'>
                            <div className='corBotao' style={{ marginLeft: '4px' }}>
                                <IconButton onClick={this.handleClicklimpar}>
                                    <Clear style={{
                                        cursor: 'pointer',
                                        width: '20px',
                                        height: '20px',
                                        fill: this.props.white ? 'white' : 'rgba(0, 0, 0, 0.54)'
                                    }} />
                                </IconButton>
                            </div>
                        </Tooltip>
                        {this.props.clickSearch ?
                            <Tooltip title={'Pesquisar'} placement='top'>
                                <div className='corBotao' style={{ marginLeft: '4px' }}>
                                    <IconButton onClick={this.handleClickSearch}>
                                        <Search style={{ cursor: 'pointer', width: '20px', height: '20px' }} />
                                    </IconButton>
                                </div>
                            </Tooltip>
                            : null}
                        {this.props.exibirBotaoIncluir ?
                            <Tooltip title={'Incluir'} placement='top'>
                                <div className='corBotao' style={{ marginLeft: '4px' }}>
                                    <IconButton onClick={this.handleClickIncluir}>
                                        <AddBox style={{ cursor: 'pointer', width: '20px', height: '20px' }} />
                                    </IconButton>
                                </div>
                            </Tooltip>
                            : null}
                    </div>
                </Paper>
            </FormControl>
        );
    }
}

export default observer(NumeroDeProcesso);
